<template>
  <div
    v-if="results && results.length"
    id="materials"
    class="nopads"
  >
      <vue3-datatable
          ref="resultTable"
          :rows="results"
          :columns="materialFields"
          :pagination="false"
          :sticky-header="true"
          height="100%"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
      ></vue3-datatable>
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {printHelper} from '../mixins/PrintMixin'
import {restApi} from '../mixins/RestApiMixin'
import {vehicleHelper} from '../mixins/VehicleMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'ManualMaterialReportDetails',
    components: {Vue3Datatable},
    mixins: [timeUtils, printHelper, restApi, vehicleHelper],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            materialFields: [
                {field: 'road_num', title: this.$t('work_report.road_no'), sort: false},
                {field: 'start_sec_num', title: this.$t('work_report.road_section_from'), sort: false},
                {field: 'end_sec_num', title: this.$t('work_report.road_section_to'), sort: false},
                {field: 'location_info', title: this.$t('work_report.location_info'), sort: false},
                {field: 'amount', title: this.$t('work_report.amount'), sort: false},
                {field: 'unit', title: this.$t('work_report.unit'), sort: false}
            ]
        }
    },
    methods: {}
}
</script>
